import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { asyncScheduler } from 'rxjs';

@Component({
  selector: 'app-daily-reward',
  templateUrl: './daily-reward.page.html',
  styleUrls: ['./daily-reward.page.scss'],
})
export class DailyRewardPage implements OnInit, AfterViewInit, OnDestroy {

  public heart = false;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    asyncScheduler.schedule(() => this.heart = true, 100);
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }

  public onClose = (event: boolean) => this.modalCtrl.dismiss(event);

}
